module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraGridPublicoAlvo),
      expression: "mostraGridPublicoAlvo"
    }]
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "ng-show": "$ctrl.isNewAvaiable()"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "uib-tooltip": "Adiciona um público alvo",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.mostraGridPublicoAlvo = !_vm.mostraGridPublicoAlvo
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo Público alvo")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "youngs",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value ? 'Sim' : 'Não'))]
      }
    }, {
      key: "women",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value ? 'Sim' : 'Não'))]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.edita(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.exclui(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])], 1)]
      }
    }])
  })], 1)], 1)])]), _vm._v(" "), (!_vm.mostraGridPublicoAlvo) ? _c('div', {
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "disabled": _vm.mostraGridPublicoAlvo,
      "ng-form": "frmAddTargetAudience",
      "ssm-isolated-form": ""
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Público-alvo')
    },
    attrs: {
      "ng-if": "$ctrl.isAval('AUDIENCE')"
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "audience"
    }
  }, [_vm._v("Público-alvo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicoAlvo.audience),
      expression: "publicoAlvo.audience"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "name": "Público-alvo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.publicoAlvo, "audience", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.publicosAlvo), function(publico) {
    return _c('option', {
      domProps: {
        "value": publico
      }
    }, [_vm._v(_vm._s(publico.description))])
  }), 0)]), _vm._v(" "), (_vm.errors.first('Público-alvo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Público-alvo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Tipo público-alvo')
    },
    attrs: {
      "ng-if": "$ctrl.isAval('AUDIENCETYPE')"
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "audienceType"
    }
  }, [_vm._v("Tipo público-alvo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicoAlvo.audienceType),
      expression: "publicoAlvo.audienceType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tipo público-alvo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.publicoAlvo, "audienceType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Outros")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("Agricultores familiares")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("Assentados da reforma agrária")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "40"
    }
  }, [_vm._v("Extrativistas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("Indígenas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "60"
    }
  }, [_vm._v("Catadores de materiais recicláveis")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "70"
    }
  }, [_vm._v("Associados")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "80"
    }
  }, [_vm._v("Jovens de 18 a 24 anos (ambos os sexos) do Programa Jovem Aprendiz no Campo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "90"
    }
  }, [_vm._v("Estudantes Ensino Superior Público (UFOB) da Área de alimentos (18 a 24 anos - ambos os sexos)")])])]), _vm._v(" "), (_vm.errors.first('Tipo público-alvo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Tipo público-alvo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('participantes diretos')
    },
    attrs: {
      "ng-if": "$ctrl.isAval('DIRECTPARTICIPANTS')"
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "directParticipants"
    }
  }, [_vm._v("Participantes diretos:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicoAlvo.directParticipants),
      expression: "publicoAlvo.directParticipants"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:2147483647'),
      expression: "'required|min_value:1|max_value:2147483647'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "participantes diretos",
      "min": "1",
      "max": "2147483647",
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.publicoAlvo.directParticipants)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.publicoAlvo, "directParticipants", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('participantes diretos')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('participantes diretos')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('participantes Indiretos')
    },
    attrs: {
      "ng-if": "$ctrl.isAval('INDIRECTPARTICIPANTS')"
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "indirectParticipants"
    }
  }, [_vm._v("Participantes indiretos:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicoAlvo.indirectParticipants),
      expression: "publicoAlvo.indirectParticipants"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max_value:2147483647'),
      expression: "'max_value:2147483647'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "participantes Indiretos",
      "type": "number",
      "max": "2147483647"
    },
    domProps: {
      "value": (_vm.publicoAlvo.indirectParticipants)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.publicoAlvo, "indirectParticipants", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('participantes Indiretos')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('participantes Indiretos')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('Atende jovens')
    },
    attrs: {
      "ng-if": "$ctrl.isAval('YOUNGSBOOL')"
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "youngsBool"
    }
  }, [_vm._v("Atende jovens?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.youngsBool),
      expression: "youngsBool"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Atende jovens"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.youngsBool = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Sim"
    },
    domProps: {
      "selected": _vm.publicoAlvo.youngs
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Não"
    }
  }, [_vm._v("Não")])])]), _vm._v(" "), (_vm.errors.first('Atende jovens')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Atende jovens')))]) : _vm._e()])]), _vm._v(" "), (_vm.youngsBool === 'Sim') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('Número de jovens atendidos')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "youngs"
    }
  }, [_vm._v("Número de jovens atendidos:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicoAlvo.youngs),
      expression: "publicoAlvo.youngs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.youngsBool === 'Sim'
      }),
      expression: "{required: youngsBool === 'Sim'}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Número de jovens atendidos",
      "type": "number",
      "min": "1",
      "max": _vm.publicoAlvo.indirectParticipants + _vm.publicoAlvo.directParticipants
    },
    domProps: {
      "value": (_vm.publicoAlvo.youngs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.publicoAlvo, "youngs", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Número de jovens atendidos')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Número de jovens atendidos')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('Atende mulheres')
    },
    attrs: {
      "ng-if": "$ctrl.isAval('WOMENBOOL')"
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "womenBool"
    }
  }, [_vm._v("Atende mulheres?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.womenBool),
      expression: "womenBool"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Atende mulheres"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.womenBool = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Sim"
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Não"
    }
  }, [_vm._v("Não")])])]), _vm._v(" "), (_vm.errors.first('Atende mulheres')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Atende mulheres')))]) : _vm._e()])]), _vm._v(" "), (_vm.womenBool === 'Sim') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('Número de mulheres atendidas')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "women"
    }
  }, [_vm._v("Número de mulheres atendidas:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicoAlvo.women),
      expression: "publicoAlvo.women"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.womenBool == 'Sim'
      }),
      expression: "{required: womenBool=='Sim'}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Número de mulheres atendidas",
      "type": "number",
      "min": "1",
      "max": _vm.publicoAlvo.indirectParticipants + _vm.publicoAlvo.directParticipants
    },
    domProps: {
      "value": (_vm.publicoAlvo.women)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.publicoAlvo, "women", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Número de mulheres atendidas')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Número de mulheres atendidas')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button",
      "id": "proposal-audience-add"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button",
      "id": "proposal-audience-cancel"
    },
    on: {
      "click": function($event) {
        return _vm.cancelaPublico()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e(), _vm._v(" "), _c('vue-snotify')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-459d9e9c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/publicoAlvoOld.vue
// module id = 1940
// module chunks = 1